import styled from 'styled-components'

import { minmedia } from '../../styles/media-queries'

export const Content = styled.p`
  font-size: 16px;
  margin-bottom: 1.5rem;
  margin-top: .5rem;
  text-align: center;

  ${minmedia.medium`
    font-size: 20px;
    margin-top: 1rem;
    margin-bottom: 2rem;
  `}
  ${minmedia.xmlarge`
    font-size: 24px;
    margin-top: 2rem;
    margin-bottom: 3rem;
  `}
`


// WEBPACK FOOTER //
// ./src/components/Sentence/styles.js